"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
var getSiteSectionLevel2_1 = require("./getSiteSectionLevel2");
// Getting Site Section Level3 with browser default props
var getSiteSectionLevel3 = function () {
    var locationPathname = (0, utils_1.removeSpecialCharacters)(window.location.pathname);
    var siteSectionLevel2 = (0, getSiteSectionLevel2_1.default)();
    return siteSectionLevel2 === undefined ||
        siteSectionLevel2 === "" ||
        locationPathname.split("/")[3] === undefined
        ? ""
        : locationPathname.split("/")[3].replace(".", "-").toLowerCase();
};
exports.default = getSiteSectionLevel3;
